import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Card } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import Logo from '../../assets/images/logo.png'
import UserService from '../../services/user';
import '../../styles/login.scss'


const FormLogin = () => {
    const [email, setEmail] = useState("")
    const [senha, setSenha] = useState("")
    const [error, setError] = useState(false);
    const [direct, setDirect] = useState(false);


    const redireciona = async () => {
        setDirect("/ti");
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const user = await UserService.login(
                {
                    email: email,
                    senha: senha
                }
            )
            console.log(user)
            if (user.data.User["_id"]) {
                await redireciona()
            }
        } catch (error) {
            setError(error)
        }
    }

    if (direct) {
        return <Navigate to={{ pathname: `${direct}` }} />
    }
    return (
        <Fragment>
            <Card className='box-login'>
                <Card.Img variant="top" src={Logo} className="logo-login" />
                <Card.Body>
                    <Form onSubmit={HandleSubmit}>
                        <Form.Group className="mb-3" controlId="email">
                            <FloatingLabel
                                label="E-mail"
                                className="mb-3"
                            >
                                <Form.Control
                                    required
                                    type="email"
                                    name="email"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />
                            </FloatingLabel>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="senha">
                            <FloatingLabel
                                label="Senha"
                                className="mb-3"
                            >

                                <Form.Control
                                    required
                                    type="password"
                                    name="senha"
                                    value={senha}
                                    onChange={e => setSenha(e.target.value)} />

                            </FloatingLabel>
                        </Form.Group>
                        {error && <Alert color="danger">{error.message}</Alert>}
                        <Button variant="outline-light" type="submit">
                            Entrar
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Fragment>
    )
}

export default FormLogin;